export default "__VITE_ASSET__Ciz1Ja0i__"